const LoadingComponent = (props) => {
  const { loading, isCentered } = props;
  const overlayStyle = {
    position: "fixed",
    top: isCentered ? "10%" : 0,
    left: isCentered ? "10%" : 0,
    width: isCentered ? "80%" : "100%",
    height: isCentered ? "90%" : "100%",
    backgroundColor: loading ? "rgba(0,0,0,0.4)" : "transparent",
    display: loading ? "flex" : "none",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
    transition: "background-color 0.3s ease", // smooth fade
  };

  const spinnerStyle = {
    width: "30px",
    height: "30px",
    border: "5px solid #081634",
    borderTop: "5px solid #EF3800",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  };
  return (
    <div style={overlayStyle}>
      <div style={spinnerStyle} />
      <style>
        {`
            @keyframes spin {
              100% { transform: rotate(360deg); }
            }
          `}
      </style>
    </div>
  );
};

export default LoadingComponent;
